import { render, staticRenderFns } from "./Shoplist.vue?vue&type=template&id=0742535c&scoped=true&"
import script from "./Shoplist.vue?vue&type=script&lang=js&"
export * from "./Shoplist.vue?vue&type=script&lang=js&"
import style0 from "./Shoplist.vue?vue&type=style&index=0&id=0742535c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0742535c",
  null
  
)

export default component.exports